import React from 'react';
import { SchoolProvider } from './context/SchoolContext';
import MainApp from './MainApp';

function App() {
    return (
        <SchoolProvider>
            <MainApp />
        </SchoolProvider>
    );
}

export default App;
